var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _rect, _polygon6, _rect2, _rect3, _polygon7, _rect4, _polygon8, _polygon9, _polygon10, _rect5, _polygon11, _polygon12, _polygon13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceCream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,146.72a5.94,5.94,0,0,1,5.95-5.94,6.1,6.1,0,0,1,1.71.25,12.32,12.32,0,0,1-.14-1.83,12.6,12.6,0,0,1,12.6-12.59,12.76,12.76,0,0,1,2.32.22,11,11,0,0,1,20.41,5.56h.18a10.15,10.15,0,0,1,0,20.29H239.43A6,6,0,0,1,233.65,146.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,171.14a6,6,0,0,1,5.95-5.94,6,6,0,0,1,1.71.25,12.32,12.32,0,0,1-.14-1.83,12.58,12.58,0,0,1,14.92-12.37,11,11,0,0,1,20.41,5.56h.18a10.15,10.15,0,0,1,0,20.29H371.22A6,6,0,0,1,365.44,171.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.65,220.26a3.6,3.6,0,0,1,4.63-3.44,8,8,0,0,1-.08-1.1,7.62,7.62,0,0,1,7.61-7.62,8,8,0,0,1,1.4.13,6.66,6.66,0,0,1,12.34,3.37h.11a6.14,6.14,0,0,1,0,12.27H203.14A3.59,3.59,0,0,1,199.65,220.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,108.29a3.59,3.59,0,0,1,3.59-3.59,3.47,3.47,0,0,1,1,.15,8,8,0,0,1-.08-1.1,7.61,7.61,0,0,1,7.61-7.61,7.32,7.32,0,0,1,1.41.13,6.65,6.65,0,0,1,12.33,3.36h.11a6.14,6.14,0,0,1,0,12.27H319.4A3.59,3.59,0,0,1,315.91,108.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.58,134.44a3.6,3.6,0,0,1,3.6-3.6,3.88,3.88,0,0,1,1,.15,8,8,0,0,1-.08-1.1,7.61,7.61,0,0,1,7.61-7.61,7.15,7.15,0,0,1,1.4.13,6.65,6.65,0,0,1,12.34,3.36h.11a6.13,6.13,0,0,1,0,12.26H93.08A3.59,3.59,0,0,1,89.58,134.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.56,366.55S114,294.91,90.28,201.62l4.8-3.62s20.76,33.7,41.58,164.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.18,179.9c-11.14-6.2-26.08,6-27,23.5a33.38,33.38,0,0,1,4.71-2.67c.51-4.41,1-8.33,1-8.33v7.86c.91-.4,1.9-.8,3-1.18l.43-4.26.63,3.9a38.54,38.54,0,0,1,4.51-1.14l1.1-12.43,1.9,12a32.08,32.08,0,0,1,4.73-.13l.62-8.45.62,8.52a30.92,30.92,0,0,1,4,.64l.56-12.58s.46,7,1,13a32.58,32.58,0,0,1,10.7,5.29v-1.54S94.34,185.56,84.18,179.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,173.27c7.76-10.12,26.32-4.84,34.1,10.84a33.07,33.07,0,0,0-5.38-.57c-2.23-3.85-4.26-7.24-4.26-7.24l3.13,7.21c-1,0-2.07,0-3.22.1l-2.09-3.74,1,3.84a37.22,37.22,0,0,0-4.6.75l-5.94-11,3,11.76a34.78,34.78,0,0,0-4.4,1.76l-3.91-7.5,2.81,8.07a30.34,30.34,0,0,0-3.47,2.19l-5.51-11.32s2.37,6.62,4.26,12.27a32.54,32.54,0,0,0-7.71,9.12l-.62-1.42S91.39,182.5,98.46,173.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23,195.22c-9.06-7.65-14.9,0-14.9,0a18.43,18.43,0,0,1,8.88,4.84l1-1.58V201c.64.64,1.25,1.31,1.85,2l1.62-4.55-.4,6c.86,1.09,1.67,2.21,2.43,3.33l.54-4.44.35,5.81c.8,1.25,1.53,2.49,2.17,3.66l.34-8.09.87,10.37c1.59,3.1,2.46,5.3,2.46,5.3S117.29,202.87,108.23,195.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.79,216.38l1.82.88c.16-1.36.35-2.8.58-4.25l-1.34-2.09,1.56.81q.12-.72.27-1.44l-1.83-4.16,2.4,1.54c1-3.93,2.28-7.43,4.13-9.19,0,0-19,7.61-6.48,27.74,0,0,.11-3.34.58-7.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,197.89l2.68-6.07-.83,6.18,1,.1,3.66-5.3-.58,5.84a37.55,37.55,0,0,1,4.15,1.2,45.4,45.4,0,0,1,4.35,1.81l1.59-5.26-.5,5.8c1.39.69,2.74,1.45,4,2.23l.65-4.58.28,5.14c1.61,1,3.13,2,4.53,3l-.71-8.16,1.85,9c1.44,1.06,2.74,2.08,3.85,3l-.26-5.68,2,7.1c1.6,1.37,2.53,2.26,2.53,2.26-2.22-19.79-10.47-27.12-23.35-28.32s-21.1,12.67-21.1,12.67S98.15,197.71,104.64,197.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,224.82l1.59,5.83c.45-1.51,1.08-3.45,1.89-5.62l-1.67-8.58,2.4,6.69a66.51,66.51,0,0,1,4.52-9.3L75.77,208,79,212.21c.53-.81,1.09-1.61,1.67-2.37l-1.31-3.71,1.82,3.05c.4-.51.81-1,1.23-1.46l-1.61-4.95,2.3,4.21A22.5,22.5,0,0,1,87,203.74l-2.47-6,3.58,5.35a14.08,14.08,0,0,1,6.28-1.79,21.36,21.36,0,0,0-11.52-7.48c-7.24-1.61-21.53,12.3-12.88,40.07,0,0,.16-.66.47-1.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,169.1l-1,3.67a8.28,8.28,0,0,1,1.34.09l1.12-4.77L77.86,173a10.22,10.22,0,0,1,2.7,1l1.55-6.45-.68,7c.33.22.68.45,1,.72l1.83-6.08-1.24,6.55A24.83,24.83,0,0,1,87.7,181v-8.72L89.55,184a70.24,70.24,0,0,1,4.83,11.18s-1-31.61-8.9-34.63-11.27,12.48-11.27,12.48a4.69,4.69,0,0,1,1-.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.36,203.4l1.11,5.93,1.86-5.93,3.42,4.29.91-4.29,3.77,2.73s-1-7.59-3.51-10.91S88.77,194.84,90.36,203.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,354.35S136.66,252,177.26,149.6l-4.89-4.37s-44.43,76.44-48.46,210.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.24,122.75c12.69-7.06,29.7,6.86,30.73,26.77a37.23,37.23,0,0,0-5.36-3c-.58-5-1.17-9.49-1.17-9.49v9c-1-.46-2.17-.92-3.41-1.35l-.49-4.86-.72,4.45a41.91,41.91,0,0,0-5.14-1.3l-1.25-14.16-2.16,13.67a35.64,35.64,0,0,0-5.4-.15l-.69-9.62-.72,9.71a34.65,34.65,0,0,0-4.61.72l-.64-14.33s-.52,8-1.1,14.76a37.42,37.42,0,0,0-12.2,6v-1.76S176.67,129.19,188.24,122.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,115.19c-8.83-11.52-30-5.5-38.85,12.36a37.62,37.62,0,0,1,6.14-.66c2.53-4.39,4.84-8.25,4.84-8.25l-3.56,8.22c1.14,0,2.36,0,3.67.12l2.38-4.26-1.11,4.37a42,42,0,0,1,5.23.85l6.78-12.5L154,128.85a35.33,35.33,0,0,1,5,2l4.46-8.55-3.2,9.19a34.65,34.65,0,0,1,3.95,2.5l6.27-12.89s-2.69,7.54-4.85,14a37.38,37.38,0,0,1,8.79,10.38l.7-1.61S180,125.71,172,115.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.84,140.2c10.32-8.72,17,0,17,0a21.14,21.14,0,0,0-10.11,5.51l-1.18-1.79v2.91c-.73.73-1.43,1.49-2.11,2.27l-1.85-5.18.45,6.87c-1,1.24-1.9,2.51-2.76,3.79l-.61-5.06-.4,6.61c-.91,1.43-1.74,2.84-2.48,4.17l-.39-9.21-1,11.81c-1.81,3.53-2.79,6-2.79,6S150.53,148.91,160.84,140.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,164.3l-2.08,1c-.18-1.55-.4-3.19-.66-4.85l1.53-2.38-1.78.93c-.09-.55-.2-1.1-.3-1.65l2.08-4.73-2.74,1.75c-1.08-4.48-2.59-8.46-4.7-10.46,0,0,21.6,8.66,7.38,31.59,0,0-.12-3.8-.65-8.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,143.24l-3.05-6.92,1,7.05-1.08.11-4.17-6,.65,6.65a40.47,40.47,0,0,0-4.72,1.36,50.51,50.51,0,0,0-5,2.07l-1.81-6,.57,6.59c-1.58.8-3.13,1.66-4.62,2.55l-.74-5.22-.32,5.86c-1.82,1.13-3.56,2.3-5.16,3.44l.81-9.3-2.1,10.23c-1.64,1.21-3.12,2.37-4.38,3.41l.29-6.47-2.22,8.08c-1.83,1.57-2.88,2.58-2.88,2.58,2.52-22.54,11.92-30.89,26.6-32.27s24,14.44,24,14.44S172.32,143,164.93,143.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.22,173.92l-1.82,6.64c-.51-1.72-1.23-3.93-2.15-6.4l1.9-9.77L200.42,172a76.68,76.68,0,0,0-5.16-10.59l2.56-6.68-3.71,4.83c-.61-.93-1.24-1.84-1.9-2.71l1.48-4.22-2.07,3.47c-.45-.57-.92-1.13-1.4-1.66l1.84-5.64-2.63,4.8a25,25,0,0,0-4.4-3.69l2.82-6.85-4.08,6.1a15.92,15.92,0,0,0-7.15-2,24.35,24.35,0,0,1,13.12-8.52c8.25-1.83,24.53,14,14.67,45.65,0,0-.17-.75-.53-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.44,110.44l1.08,4.19a9.49,9.49,0,0,0-1.52.1l-1.28-5.43.72,5.53a12,12,0,0,0-3.08,1.15l-1.76-7.35.77,7.92c-.38.25-.77.52-1.17.82l-2.09-6.93,1.42,7.47a28.38,28.38,0,0,0-5.3,6.08v-9.93l-2.11,13.4a80.71,80.71,0,0,0-5.5,12.74s1.19-36,10.14-39.44S199.6,115,199.6,115a5.58,5.58,0,0,0-1.17-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,149.52l-1.27,6.76-2.12-6.76-3.9,4.89-1-4.89-4.3,3.11s1.13-8.65,4-12.43S183,139.76,181.2,149.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,359c2.07-2.35,4-4.74,6.21-7a1.74,1.74,0,0,0,.31-.38,18.7,18.7,0,0,1,2.24-1.23l1.07-.4c.87-.32,1.74-.67,2.6-1,5.46-2.19,10.37-4.74,14.49-9.07,2.25-2.38,4.06-5.15,6.4-7.45.05.08.51-.16.73-.34.7-.08,1.64-.22,1.77-.23.94,0,1.89,0,2.83.06,1.35.06,2.69.17,4,.29,5.24,7.67,11.86,18.13,14.79,19.51,4.52,2.14,46.23,13.16,49.3,12.51s19.18.65,23.22.5,11.36-1.95,22-6.82,16.39-4.91,29.16-9,21.32-5.62,28.79.64,28-6.95,34.39-8.83,18.63-12.72,27-7.67,15.29,7.46,25.72,16.5,31.13,26.49,31.13,26.49H72.73l4-7.07A29,29,0,0,0,97,359Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.14,376.88v4.7h386v-4.7a4.08,4.08,0,0,0-4-4.3H58.18A4.08,4.08,0,0,0,54.14,376.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.14,
    y: 372.58,
    width: 24,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.14,
    y: 372.58,
    width: 23,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.14,
    y: 372.58,
    width: 24,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.14,
    y: 372.58,
    width: 23,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.14,
    y: 372.58,
    width: 23,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.14,
    y: 372.58,
    width: 24,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.14,
    y: 372.58,
    width: 23,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.14,
    y: 372.58,
    width: 24,
    height: 9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,212.57s1.24,5.13,9.68,7.78,1.43,9.32,2.87,9.42,14.13-.35,14.33,5.84-3.62,8.26-3.62,8.26,20.18.92,10.16,10-60.25,9.58-64.61,1.29,10.89-13,10.89-13-4.47-7,0-10.4,14.8-4.83,13.88-4.71S351.57,221,364,212.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.84,314.22v46.93H259.36V322.3A11.46,11.46,0,0,1,267,311.55l24.43-8.85.52-1.07L309,266.94a23.52,23.52,0,0,1,21-13.09h74.73a14.74,14.74,0,0,1,14.09,10.37C423.61,279.51,431.84,307.06,431.84,314.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.76,
    cy: 363.07,
    r: 18.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.76,
    cy: 363.07,
    r: 11.93,
    transform: "translate(-170.69 314.06) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.37,
    cy: 363.07,
    r: 18.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.37,
    cy: 363.07,
    r: 11.93,
    transform: "translate(-140.34 387.32) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.61,
    y: 348.72,
    width: 16.25,
    height: 16.25,
    rx: 1.62,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.09,
    y: 348.72,
    width: 16.25,
    height: 16.25,
    rx: 1.62,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,264.28,300.19,300.5l-8.29,1.13L309,266.94a23.3,23.3,0,0,1,1.54-2.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.6 264.28 350.98 264.28 347.9 299.75 305.68 299.75 320.6 264.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,294.5v2.41h-1.13v7.93h1.13v2.43h-6.06v-2.43h1.15v-7.93h-1.15V294.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,305a7.48,7.48,0,0,1-5.54,2.57c-3.87,0-6.45-2.48-6.45-6.56s3.16-6.72,5.56-6.72a3.36,3.36,0,0,1,2.81,1.24l.42-1h2.87v5.19h-3.27c-.05-1.19-.64-2.31-1.94-2.31s-2.17,1.63-2.17,3.62c0,1.81.93,3.44,2.67,3.44,1.53,0,2.74-1.61,2.9-1.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.72,294.5v4h-3.16v-1.62h-2.93v2.52h3.48v2.43h-3.48v3h2.93v-1.7h3.16v4.13h-11v-2.43h1.15v-7.93H381.7V294.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.06,317.61a5.7,5.7,0,0,1-4.21,2,4.62,4.62,0,0,1-4.91-5c0-3.2,2.4-5.12,4.23-5.12a2.57,2.57,0,0,1,2.14,1l.32-.78h2.18v3.95h-2.49c0-.91-.49-1.76-1.47-1.76s-1.66,1.24-1.66,2.76.71,2.61,2,2.61a3.3,3.3,0,0,0,2.21-1.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.14,309.63c3.23,0,3.86,1.28,3.86,2.86a2.13,2.13,0,0,1-2,2,2.1,2.1,0,0,1,1.82,2c0,.6.08.95.33.95s.32-.17.32-.45v-.45h.94v.76c0,1.15-.49,2.22-2,2.22-1.83,0-2.7-.95-2.7-2.58,0-1.27-.16-1.57-1.39-1.57v2.15h.85v1.84h-4.5v-1.84h.78v-6.06h-.78v-1.82Zm-.87,4.17h.62c.81,0,1.34-.39,1.34-1.13a1.13,1.13,0,0,0-1.27-1.24h-.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.26,309.63v3.07h-2.4v-1.24h-2.23v1.92h2.65v1.85h-2.65v2.27h2.23v-1.3h2.4v3.15h-8.38V317.5h.87v-6h-.87v-1.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.28,319.35v-1.82h1.32l-.29-.95h-2.85l-.3.95h1.09v1.82h-4.42v-1.82h.94l1.88-6.11h-.57v-1.79h5.34l2.46,7.9h1v1.82Zm.51-4.44-.91-3-.91,3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,312.07c-.11.63-.31,1.55-.4,1.87l-1.46,5.41H407.3l-1.56-5.55a9.37,9.37,0,0,1-.29-1.73h-.06v5.48h.8v1.8h-3.77v-1.8h.75v-6.13h-.74v-1.79h5.27l1.41,5.2,1.33-5.2h5.3v1.79H415v6.12h.76v1.81h-4.39v-1.81h.78v-5.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25,279.42s-1,4.13,2.91,5.05,2.34,5.73,2.34,5.73,4.77-.92,5.46,2.75.23,5.51,0,5.51a3.06,3.06,0,0,1,1.91,4.1c-1,3.47-15.59,6-18.5,2.55s.73-7.11.73-7.11-1.49-4.13-.73-6.19,4.31-2.76,4.31-2.76S397.58,284.93,403.25,279.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.81,319.57h0a1.93,1.93,0,0,1,1.93,1.93v14.94a1.93,1.93,0,0,1-1.93,1.93h0a1.92,1.92,0,0,1-1.93-1.93V321.5A1.92,1.92,0,0,1,263.81,319.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.19,342.21a.5.5,0,0,1-.5-.5V304.65a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v37.06A.51.51,0,0,1,304.19,342.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.48,346.92a.5.5,0,0,1-.5-.5V299.74l1.61-35.48a.5.5,0,1,1,1,0L353,299.77v46.65A.5.5,0,0,1,352.48,346.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.92,
    y: 355.89,
    width: 59.97,
    height: 7.1,
    rx: 1.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.18,
    y: 306.75,
    width: 8.95,
    height: 2.88,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-6",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.35,372.76s-7.75-9.23-12.71-4.93-2.46,13.43,3.27,13.73a14.37,14.37,0,0,0,9.44-2.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,372.76s-7.75-9.23-12.71-4.93-2.46,13.43,3.27,13.73a14.37,14.37,0,0,0,9.44-2.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,349.35s6.52-6.82,10.55-5.66,3.61,17.45-8.9,10.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,349.35s6.52-6.82,10.55-5.66,3.61,17.45-8.9,10.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,400.24s-21.39-29.27-4-35.2,20.47,23.55,15.51,31.76S377.72,400.24,377.72,400.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,340.31s13.27-30.82-6.39-31.75-21.8,30.56.82,35.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,400.24s-21.39-29.27-4-35.2,20.47,23.55,15.51,31.76S377.72,400.24,377.72,400.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,340.31s13.27-30.82-6.39-31.75-21.8,30.56.82,35.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.94,365.54s-6.46-27.21,5.95-29.38,24.65,22.42-1,34.78C387.88,370.94,383.48,368.21,382.94,365.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.94,365.54s-6.46-27.21,5.95-29.38,24.65,22.42-1,34.78C387.88,370.94,383.48,368.21,382.94,365.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.32 396.09 398.25 396.09 395.25 419.08 365.32 419.08 362.32 396.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,338.11a25.25,25.25,0,0,1-5-4.88,24.76,24.76,0,0,1-3.53-6.08,18.51,18.51,0,0,1-1.28-6.93,16.64,16.64,0,0,1,1.61-6.79c-.12.58-.25,1.14-.39,1.7l-.2.83c0,.28-.06.57-.09.85-.06.57-.14,1.13-.19,1.7l0,1.7a21.34,21.34,0,0,0,1.45,6.58,31.06,31.06,0,0,0,3.21,6,30.29,30.29,0,0,0,2.06,2.75A31,31,0,0,0,381,338.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.3,311.66a12.32,12.32,0,0,1,3.21,1.1,14.71,14.71,0,0,1,2.84,1.94,15.17,15.17,0,0,1,4,5.59,19.94,19.94,0,0,1,1.37,6.72c0,1.14-.07,2.28-.11,3.41-.2,1.12-.36,2.23-.58,3.34,0-1.14.06-2.25.09-3.37s-.06-2.23-.17-3.33a29.17,29.17,0,0,0-.55-3.26c-.15-.53-.23-1.07-.41-1.59l-.57-1.54A16.22,16.22,0,0,0,376.3,311.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.33,338.11a11.7,11.7,0,0,1,6.52,6.26,14.07,14.07,0,0,1,1.22,4.49,5.85,5.85,0,0,1,.07,1.18c0,.4,0,.8,0,1.2a13.89,13.89,0,0,1-.46,2.31,19.61,19.61,0,0,1-1.89,4.26,30.42,30.42,0,0,1-2.69,3.75,38.31,38.31,0,0,1-6.65,6.27c1.09-1.06,2.16-2.13,3.15-3.27a43.33,43.33,0,0,0,2.89-3.48,25.06,25.06,0,0,0,4.23-7.81,13,13,0,0,0,.45-2.13,9.93,9.93,0,0,0,0-1.09,5.71,5.71,0,0,0,0-1.09,15.38,15.38,0,0,0-1-4.29,12.34,12.34,0,0,0-2.3-3.78A11.53,11.53,0,0,0,391.33,338.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,340.31a24.43,24.43,0,0,1,1.37,6.23,14.14,14.14,0,0,1,0,3.25,7.7,7.7,0,0,1-1,3.19,12,12,0,0,0-1.81,5.76,27.32,27.32,0,0,0-.14,3.13c0,1.06,0,2.11.07,3.17a23.7,23.7,0,0,1-.69-6.35,15.4,15.4,0,0,1,.39-3.22,10,10,0,0,1,.54-1.57,13.89,13.89,0,0,1,.79-1.45,7,7,0,0,0,.94-2.79,18.47,18.47,0,0,0,.19-3.08,29.89,29.89,0,0,0-.2-3.13C388,342.4,387.81,341.36,387.65,340.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.92,367.83a2.85,2.85,0,0,1,1.33,1,9.39,9.39,0,0,1,1,1.4,25,25,0,0,1,1.35,3.1,50.21,50.21,0,0,1,1.77,6.46c.45,2.19.82,4.39,1.06,6.61a46.51,46.51,0,0,1,.35,6.68c-.16-1.11-.33-2.2-.54-3.29s-.37-2.19-.57-3.28c-.42-2.17-.81-4.35-1.28-6.51s-.94-4.32-1.52-6.44a23.72,23.72,0,0,0-1.06-3.11A8.75,8.75,0,0,0,380,369,3.14,3.14,0,0,0,378.92,367.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.84,368.78a28,28,0,0,0-1,6.06,23.52,23.52,0,0,0,.44,6.05,20.73,20.73,0,0,0,2,5.7,30,30,0,0,0,3.43,5.1c-.38-.34-.77-.7-1.14-1.06a10.57,10.57,0,0,1-1.11-1.11,19.51,19.51,0,0,1-3.29-5.38c-.21-.49-.33-1-.5-1.51a10.22,10.22,0,0,1-.39-1.54,19.73,19.73,0,0,1-.23-6.32A18.35,18.35,0,0,1,372.84,368.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,352.68a26.57,26.57,0,0,0,3.19-1,8.43,8.43,0,0,0,1.39-.74,13.06,13.06,0,0,0,1.31-1.08,3.21,3.21,0,0,1-.79,1.66,4.28,4.28,0,0,1-1.52,1.08,5.11,5.11,0,0,1-1.79.4A4.22,4.22,0,0,1,406,352.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.71,348.18a4.31,4.31,0,0,1,1.18-1.4,4.73,4.73,0,0,1,1.66-.88,3.75,3.75,0,0,1,1.94,0A2.78,2.78,0,0,1,411,347a6.32,6.32,0,0,0-1.64-.36,5.7,5.7,0,0,0-1.53.21,10.51,10.51,0,0,0-1.52.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.81,374.13a36.3,36.3,0,0,0-3.94-2.84,5.31,5.31,0,0,0-2.11-.78,4,4,0,0,0-2.27.43,3,3,0,0,1,2.29-1.21,4.61,4.61,0,0,1,2.58.69,8.56,8.56,0,0,1,2,1.62A8.11,8.11,0,0,1,365.81,374.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.81,378.67a11.25,11.25,0,0,1-2.91.65,12.24,12.24,0,0,1-3-.1,6.35,6.35,0,0,1-2.87-1.16,3.38,3.38,0,0,1-1.4-2.67,4.1,4.1,0,0,0,1.84,2,8.08,8.08,0,0,0,2.6.83A48.58,48.58,0,0,0,365.81,378.67Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ice-cream--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.11,419.08h65.12s-2-10.75-10.56-11.24-10.1-.67-13.83-6.38-8.28-.75-13.66-3S283,386.35,283,386.35s-6.71,10.3-3,14.86c0,0-10.9,1.17-8.87,5.5S260.83,411.53,264.11,419.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,419.08H264.11c-2.78-6.39,5.62-7.72,7.05-10.61a2,2,0,0,0,0-1.76c-1.1-2.34,1.58-3.76,4.28-4.56a28.93,28.93,0,0,1,4.59-.94,5.15,5.15,0,0,1-1.05-2.52c-.71-5,4.05-12.34,4.05-12.34s2.81,9.92,8.18,12.14,9.93-2.74,13.66,3,5.24,5.89,13.83,6.38a9.47,9.47,0,0,1,6.32,2.88A18,18,0,0,1,329.23,419.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,410.72c-3.07,1.7-8.06,2.86-14.45,4-15.49,2.81-24.13-1.19-18.79-2s12.26-5.29,9.49-4.87c-2.55.39-24.09,2.73-30.08.63a2,2,0,0,0,0-1.76c-1.1-2.34,1.58-3.76,4.28-4.56,7,5.69,15-.69,15-.69s-5.62,1.21-10.17-1.36a3.33,3.33,0,0,1-1.32-1.41c-.71-5,4.05-12.34,4.05-12.34s2.81,9.92,8.18,12.14,9.93-2.74,13.66,3,5.24,5.89,13.83,6.38A9.47,9.47,0,0,1,325,410.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.56,
    y: 138,
    width: 30.29,
    height: 30.29,
    rx: 3.69,
    transform: "translate(261.29 304.68) rotate(179.29)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2,166s4.09,9,13,11.76c0,0-5-2.78-4.69-12.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.09,158.73a1.57,1.57,0,0,1,1.64-1.55,1.56,1.56,0,1,1,0,3.12A1.58,1.58,0,0,1,128.09,158.73Zm.15-12.68h3l-.51,9.44h-2Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.45,217.61c3.68,2,14.74,13.88,14.74,13.88l-9.79,7.93-11.67-7.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,231.48l-9.79,7.94L176,237.8,169,233l-2.28-1.55,6.72-13.87C177.13,219.63,188.19,231.48,188.19,231.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,237.8,169,233a22.24,22.24,0,0,1,.89-5.11A15.05,15.05,0,0,1,176,237.8Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,224l-13.79-1.27,8.42-7.1L160,210s-14.82-5.75-17.67-4.89l-1.29,6,5.5,10.85-15.62-1.44L122.35,267c21.05,9.09,50.3,3.6,50.3,3.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,224l-13.79-1.27,8.42-7.1L160,210s-14.82-5.75-17.67-4.89l-1.29,6,5.5,10.85-15.62-1.44L122.35,267c21.05,9.09,50.3,3.6,50.3,3.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17,294.36s37.65,40.58,41.29,43.61,54.45,75.45,54.45,75.45l6.3-4.47S192,335.48,187.56,327.6s-36.67-55.05-36.67-55.05Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,301.26s2.66,33.87,0,47.07-59.73,65.33-59.73,65.33l-6.14-3.22s49.13-58,49.51-65.26S122,304.86,122,304.86Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.36,313.68c-12.58-20-22.44-34.55-22.44-34.55L159.27,259l-37-3.35s-8.88,23.28-6.48,40.56c1.11,8,2.19,23.51,4.52,33.89l25.94-4.27c-.11-8.46-.27-15.22-.27-15.22s7.43,8.71,18.93,21.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,410.44H76.64A.64.64,0,0,0,76,411l-1.5,6.76a1.13,1.13,0,0,0,.86,1.33l.25,0c3-.05,5.16-.23,8.91-.23,2.3,0,9.27.24,12.45.24s3.61-3.15,2.3-3.44c-5.85-1.27-10.25-3-12.13-4.72A1.82,1.82,0,0,0,85.87,410.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,406.85l-8.59,3.36a.67.67,0,0,0-.41.72l1.07,6.85a1.12,1.12,0,0,0,1.29.92l.24-.07c2.76-1.13,4.71-2.09,8.2-3.46,2.15-.84,8.73-3.15,11.69-4.31s2.21-4.25.89-4c-5.91.94-10.66.9-13,0A1.85,1.85,0,0,0,237.76,406.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.82,265.06c4.29-31.25,12.63-47.45,12.63-47.45-19-7.34-42.95-11.08-42.95-11.08-6.65,17.05-9.26,41.43-10.14,54.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.52,293,146,310.56s7.43,8.71,18.93,21.62c-12.2-19.7-15.5-33.27-15.5-33.27,4-5.32,4.4-13.82,4.4-13.82Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,156c-6-4.85-5.12-17.67,3.17-21.7a22.08,22.08,0,0,0,8.33-6.47c2.56-3.21,4.75-7.54,8.49-14.2,6.89-12.23,28.86-19.4,42-14.33a26.81,26.81,0,0,1,12.58,9.38c2.38,3.11,4.08,6,7.34,7.79,6.72,3.63,13.66,1.23,18.08,15.1S229.67,189.53,188.35,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,108.65c-.56,2.57-3.17,4-6.84,3.53-8.34-1.07-11.68-6.53-23-2.4s-4-.15-4.94-3-12.07,3.61-13.14,7.89c-.83,3.35-7.21,12.71-15.13,13.11,2.56-3.21,4.75-7.54,8.49-14.2,6.89-12.23,28.86-19.4,42-14.33A26.81,26.81,0,0,1,262.9,108.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,199.08c-4.93,8.54-12.16,10.29-13.76,15.3a6.62,6.62,0,0,0-.31,1.77,11,11,0,0,1-4.21,8.3c-5,3.93-13.25,3.68-18.73-3.37C270.4,210.61,282,189.51,262,184.6s-27.52-15.92-17.44-22.71-1.41-15.26.33-25.1c3.58-20.36,24.07-11.6,24.07-11.6a29.86,29.86,0,0,1,13.87-3.6c14.32-.32,32.15,8.7,36.46,42C321.67,182.22,319.27,192.6,315.55,199.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,199.08c-4.93,8.54-12.16,10.29-13.76,15.3-2.38.37-4.52-.12-5.87-1.68-3.51-4-5.86,9.6,1.35,11.75-5,3.93-13.25,3.68-18.73-3.37C270.4,210.61,282,189.51,262,184.6s-27.52-15.92-17.44-22.71-1.41-15.26.33-25.1c3.58-20.36,24.07-11.6,24.07-11.6a29.86,29.86,0,0,1,13.87-3.6c-3.53,1.93-6.31,4.19-5.45,6.27,2.06,5,9.23,11.29,10.67,19.5s-1.69,13.68,5.34,21,19.77,12.2,22.6,11.38-.46,5.5-4.78,5.7-9.69-1.36-15-7.62-1.42,18.51,5.86,20.57C307.48,200,314.07,197,315.55,199.08Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.44,214.75,176.21,357.34l0,0h0l5.39-182.69,3.79,1.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.64 178.41 181.57 174.71 181.18 187.97 193.44 182.31 191.64 178.41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.76 206.7 231.92 196.46 230.12 192.56 203.42 182.74 199.52 184.54 209.76 206.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "248.24 220.86 270.4 210.61 268.6 206.72 241.9 196.89 238 198.69 248.24 220.86"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "282.15 225.11 290.45 214.75 280.38 211.05 276.48 212.85 282.15 225.11"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.24 209.62 195 187.45 181.01 193.92 180.41 214.09 183.08 219.86 205.24 209.62"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 215.31,
    y: 205.6,
    width: 24.41,
    height: 24.41,
    transform: "translate(-70.39 115.55) rotate(-24.81)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.8 226 260.04 248.17 265.81 245.5 278.43 229.75 271.96 215.76 249.8 226"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 188.63,
    y: 218.76,
    width: 24.41,
    height: 24.41,
    transform: "translate(-78.37 105.57) rotate(-24.81)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 227.11,
    y: 232.91,
    width: 24.41,
    height: 24.41,
    transform: "translate(-80.76 123.02) rotate(-24.81)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "180.11 227.92 180 227.97 179.2 255.24 190.35 250.08 180.11 227.92"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200.43,
    y: 246.07,
    width: 24.41,
    height: 24.41,
    transform: "translate(-88.74 113.04) rotate(-24.81)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.92 266.47 240.07 277.63 257.13 256.34 257.08 256.23 234.92 266.47"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.15 277.39 191.91 255.23 179.02 261.19 178.34 284.07 179.99 287.63 202.15 277.39"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "208.23 279.63 218.48 301.79 222.04 300.14 236.35 282.28 230.39 269.38 208.23 279.63"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185.54,
    y: 286.54,
    width: 24.41,
    height: 24.41,
    transform: "translate(-107.09 110.53) rotate(-24.81)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "177.94 297.68 177.21 322.51 187.27 317.86 177.94 297.68"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "198 330.15 213.53 310.77 193.35 320.09 198 330.15"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.27 354.78 194.28 334.8 188.83 323.01 177.03 328.46 176.28 354.05 176.91 355.41 178.27 354.78"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.21,357.34c1.24-1.95,42.48-66.72,39.88-73.09s3.71-21.67,7.43-35.92.17-28.24.5-32.92-6.33-21.71-18.67-22.63c-9.06-.68-16.62-11.17-20-16.68l105.08,38.65Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,213c-1.43,4.55-3.94,8.38-6,13a36.27,36.27,0,0,0-3.18,17.09c0,.21,0,.42,0,.65.72,12.51-.64,22.6-3.08,28-1.84,4.09-4.28,5.57-6.92,3.53-6.15-4.77-3.37-29.41-4.69-47.11S243.87,208.63,242,223s-12.3,25.52-13.4,13.91,3.06-20-3.92-25.12-3.1-18.19-11.46-23.8-17.87,1.7-27.56-4-8.4-13.35-8.4-13.35c.28-9.18,7.53-5.32,11.95-23.86a30.31,30.31,0,0,1,6.11-11.72c11.31-14.05,35.3-25.06,58.31-18.11,29.22,8.83,31,38.47,28.93,53.59a27.53,27.53,0,0,0-.28,6.95c.78,6.79,5.66,6.1,8.94,21.61A26.2,26.2,0,0,1,290.75,213Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,213c-1.43,4.55-3.94,8.38-6,13a36.27,36.27,0,0,0-3.18,17.09c0,.21,0,.42,0,.65.72,12.51-.64,22.6-3.08,28-1.84,4.09-4.28,5.57-6.92,3.53-6.15-4.77-3.37-29.41-4.69-47.11S243.87,208.63,242,223s-12.3,25.52-13.4,13.91,3.06-20-3.92-25.12-3.1-18.19-11.46-23.8-17.87,1.7-27.56-4-8.4-13.35-8.4-13.35c.28-9.18,7.53-5.32,11.95-23.86a30.31,30.31,0,0,1,6.11-11.72c11.31-14.05,35.3-25.06,58.31-18.11,29.22,8.83,31,38.47,28.93,53.59a27.53,27.53,0,0,0-.28,6.95c.78,6.79,5.66,6.1,8.94,21.61A26.2,26.2,0,0,1,290.75,213Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.61,243.73c.72,12.51-.64,22.6-3.08,28-11.61-.5-6-25-.7-26.24a10.28,10.28,0,0,0,3.76-2.46C281.59,243.29,281.6,243.5,281.61,243.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,213c-1.43,4.55-3.94,8.38-6,13-9.51,0-12.8-16.41-5.71-12.94A14,14,0,0,0,290.75,213Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,192.12a12.07,12.07,0,0,1-.18,1.72,14.13,14.13,0,1,1-13.41-16.37,13.52,13.52,0,0,1,3.79.68A14.11,14.11,0,0,1,299.39,192.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,185.63a2.09,2.09,0,1,1-2-2.17A2.1,2.1,0,0,1,280,185.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,192.51c.35,2.05-.29,3.87-1.43,4.07s-2.34-1.32-2.69-3.38.29-3.87,1.43-4.07S277.25,190.45,277.6,192.51Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,192.12a12.07,12.07,0,0,1-.18,1.72c-.56-2-1.46-4-2.9-4.14-3-.2-6.13.92-8.14-1.24s1.88-4.27,2.17-6.91a6,6,0,0,0-.75-3.4A14.11,14.11,0,0,1,299.39,192.12Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93,182.31c-17.12-12.84-33.39-1.6-37.2,1.42a6.09,6.09,0,0,0-2.38,0c-.58.32-1.16,3.82,1.39,4,1.41.11,1.77-1.09,1.82-2.19,2.54-2.12,18.44-14.27,35.22-1.69a1,1,0,1,0,1.15-1.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.93,182.31c-17.12-12.84-33.39-1.6-37.2,1.42a6.09,6.09,0,0,0-2.38,0c-.58.32-1.16,3.82,1.39,4,1.41.11,1.77-1.09,1.82-2.19,2.54-2.12,18.44-14.27,35.22-1.69a1,1,0,1,0,1.15-1.54Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.64,174.09c1.45,1.93,8.29,2,8.48,4.08s-3.92,2.49-7.3,1.52-7.89.77-8.26,3.65-.11,4.27-1.72,5.47-2.59,5.8-.55,8.39S260.8,211.82,260,199.87s15.68-26.8,15.68-26.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.64,174.09c1.45,1.93,8.29,2,8.48,4.08s-3.92,2.49-7.3,1.52-7.89.77-8.26,3.65-.11,4.27-1.72,5.47-2.59,5.8-.55,8.39S260.8,211.82,260,199.87s15.68-26.8,15.68-26.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.55,170.53c-.15,1.09-.27,2.18-.34,3.28,0,.49-.27,1,0,1.52s1,.73,1.61.82a14.92,14.92,0,0,1,2.73.59,2.56,2.56,0,0,1,.95.54,1,1,0,0,1,.28,1c-.19.51-.81.67-1.33.76a4.15,4.15,0,0,1-1.95,0c-.63-.2-1.26-.36-1.87-.61-.42-.17-.81-.38-1.23-.53a9.53,9.53,0,0,0-2.81-.43c-2.29-.12-5.7.52-5.79,3.4-.15,5.1-.5,6.77-4.89,8.45s-5.36,7.86-5.27,15.54-12.07.24-14.33-2.72S256.11,198,256,195s-6.14-5.34-13.65-1.52-2.58,14.58-8.48,14.18-3.92-8.35-7.27-15.78,10.11-15.05-2.12-16.67c-4.58-.61-10.79-2.14-11.54-6s16-4,15-11.62-8.21-2.59-16.35-2.14a17,17,0,0,1-17.19-10.8c-.93-2.35-.27-5.92,1-9.57,11.31-14.05,35.3-25.06,58.31-18.11C282.84,125.77,284.62,155.41,282.55,170.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,215.51s-8.36-2-10.45-6.27a6.75,6.75,0,0,0,2.36-2c2.88-3.7,4.21-10.66,4.7-14.94l6.94,11.12v0c-.34.57-.69,1.17-1,1.76l-.07.14a9.41,9.41,0,0,0-1,3.32,5.07,5.07,0,0,0,.46,2.43,7.32,7.32,0,0,0,3.05,3.09C160.39,216.11,154.89,215.51,154.89,215.51Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,203.4c-.34.57-.69,1.17-1,1.76l-.07.14a9.41,9.41,0,0,0-1,3.32,5.07,5.07,0,0,0,.46,2.43c-6.62-2-6.7-11.71-6.7-11.71s4.28,1.81,8.23,4Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,189.81c-1.16.85,2.67,4.16,9.71,2.8s9.16-8,9.16-8S148.83,184.26,141.24,189.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,189.81c-1.16.85,2.67,4.16,9.71,2.8s9.16-8,9.16-8S148.83,184.26,141.24,189.81Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.21,186.6c-3.38.87-3.26,4.44,1.14,11.54,3.66-2.35,6.33-8.5,4.91-10.79S169.15,185.85,166.21,186.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,201.39a0,0,0,0,1,0,0,21.7,21.7,0,0,1-1.37,2.35c-4.05,6-13.28,5.94-16.4-1l0-.07c-2-4.64-.49-8.49,1.59-15.24a9.66,9.66,0,0,1,15.82-4.31C173.26,187.56,171.79,195.78,168.93,201.39Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,193c-.21.53-.08,1.08.27,1.21s.79-.2,1-.73.09-1.08-.26-1.22S162.11,192.49,161.88,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,195.32c-.2.53-.08,1.08.27,1.21s.8-.19,1-.74.08-1.08-.28-1.21S168.18,194.78,168,195.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,194.82a20.19,20.19,0,0,0,.84,5.56,3.31,3.31,0,0,1-2.75-.49Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.93,190.45a.36.36,0,0,1-.18-.12.34.34,0,0,1,.1-.47,3.36,3.36,0,0,1,3.06-.33.34.34,0,0,1,.18.43v0a.36.36,0,0,1-.45.16h0a2.68,2.68,0,0,0-2.41.29A.33.33,0,0,1,160.93,190.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.53,194.31a.37.37,0,0,1-.22-.29,2.68,2.68,0,0,0-1.23-2.1.34.34,0,0,1,.31-.6A3.36,3.36,0,0,1,172,194a.33.33,0,0,1-.3.36h0A.38.38,0,0,1,171.53,194.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,182.62c2.68,2.23,1.05,5.41-5.95,9.95-2.31-3.68-2.11-10.39.16-11.84S155.19,180.69,157.54,182.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,191.57a6.74,6.74,0,0,0,1.57,4.89c1.54,1.78,3.6.71,4.26-1.41.6-1.92.51-5.16-1.56-6.16A3,3,0,0,0,147.57,191.57Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,184.41a6.54,6.54,0,0,1,2.48,2.3,1.64,1.64,0,0,0,.19-1.39,10.09,10.09,0,0,1,2.61,2.81A5,5,0,0,0,166,186a13.33,13.33,0,0,1,.9,3s2.47-.53,3-2.35a9.16,9.16,0,0,1-.34,2.4,3,3,0,0,0,2.2-1.83,8.16,8.16,0,0,1,0,3,2.77,2.77,0,0,0,1.69-3.05c-.17-2.48-6.44-7.15-10.54-6.54S160,184.41,160,184.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,188.17s.9-7-1.55-10-12.4-5.26-17.75-3.37-4.87,11.55-4.87,11.55S160.28,182.61,173.5,188.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.31,185.44a15.93,15.93,0,0,0-6.21-1.4s-1.33-3.35,3.1-2.91C170.41,181.45,170.81,183.23,170.31,185.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.92,185.3l-5.57-.74a27.93,27.93,0,0,0-8.11,5.25S146,186.69,154.92,185.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.92,185.3l-5.57-.74a27.93,27.93,0,0,0-8.11,5.25S146,186.69,154.92,185.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35,202.37a3.81,3.81,0,0,1-3.1.83,4.74,4.74,0,0,1-1.6-.6c-1.55-.9-2.17-2.18-2-3a1,1,0,0,1,.63-.77,1.75,1.75,0,0,1,1.17,0,10.07,10.07,0,0,1,4.19,2.83C163.08,202.06,163.35,202.37,163.35,202.37Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,201.6l-.86.48a30.45,30.45,0,0,0-4.5-3.27,1.75,1.75,0,0,1,1.17,0A10.07,10.07,0,0,1,162.64,201.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,203.2a4.74,4.74,0,0,1-1.6-.6c-1.55-.9-2.17-2.18-2-3C158.32,199.9,161,200.8,160.25,203.2Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,205.09l4.58,8.24-5.66,4.28-16.1,54.69-14-4.47s9.28-47.27,19.39-61.3l8.3,1.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,274.8s-9.22-30.8-4-57.19l-8.86-3.25L160,210a16.46,16.46,0,0,1,.88,7.18l1.32,4.38h0c.89,15,3.46,45.91,9.79,54.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.9,213.33l-5.66,4.28-16.1,54.69-14-4.48a413.24,413.24,0,0,1,10.34-40.65,131.39,131.39,0,0,1,5.12-13.56,42.33,42.33,0,0,1,3.93-7.08l8.3,1.31,3.52-2.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,274.8s-9.22-30.8-4-57.19l-8.86-3.25L160,210a16.46,16.46,0,0,1,.88,7.18l1.32,4.38h0c.89,15,3.46,45.91,9.79,54.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.32 205.09 138.52 206.53 139.85 214.88 146.9 213.33 142.32 205.09",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,210l5.36,3.67.84,6.84-5.32-3.33A17.31,17.31,0,0,0,160,210Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.32 205.09 138.52 206.53 139.85 214.88 146.9 213.33 142.32 205.09",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,210l5.36,3.67.84,6.84-5.32-3.33A17.31,17.31,0,0,0,160,210Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,232c-4.39,1.83-7.51-1.39-9.46-4.79a131.39,131.39,0,0,1,5.12-13.56C131.76,218.62,137.07,229.39,130.91,232Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.59,229.71l-1.12-1.57.19,1.93A9.42,9.42,0,0,1,147.59,229.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.11,227.63l-.82,1.76a8.05,8.05,0,0,1,1,.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.31,227.63l-.16,1.94a8.05,8.05,0,0,1,1-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,229.34l-.5-1.88-.5,1.88.5,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13,230.32,144.74,229l.54,1.86C145.55,230.65,145.84,230.48,146.13,230.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,231.18l-1.61-1.08.86,1.74A7.87,7.87,0,0,1,144.81,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,233.52l-1.9-.45,1.43,1.34A9.42,9.42,0,0,1,142.72,233.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66,232.26l-1.78-.78L143,233A9.22,9.22,0,0,1,143.66,232.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,233l1.15-1.56-1.78.78Q157.09,232.64,157.39,233Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,237.45l1.81-.76-1.93-.24A8,8,0,0,1,159,237.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.71,235.89l1.64-1.06-1.95.1A9.78,9.78,0,0,1,158.71,235.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,238.6,159,238s0,.06,0,.09c0,.31,0,.62-.05.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,234.41l1.43-1.34-1.9.45A9.42,9.42,0,0,1,158.17,234.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,229l-1.39,1.35c.3.16.58.33.86.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,234.93l-2-.1,1.65,1.06A7.65,7.65,0,0,1,142,234.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,228.14l-1.12,1.57c.31.1.62.23.93.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.37,231.84l.85-1.74-1.61,1.08A9.45,9.45,0,0,1,156.37,231.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,238.1V238l-1.87.59,1.91.42C141.44,238.72,141.43,238.41,141.43,238.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18,244.53l1.74,1-1-1.69A8.16,8.16,0,0,1,156.18,244.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.94,245.5l1.54,1.25-.71-1.85A9.71,9.71,0,0,1,154.94,245.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55,246.23l1.29,1.5-.37-1.95A8.68,8.68,0,0,1,153.55,246.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,246.69l1,1.71,0-2C152.71,246.52,152.38,246.62,152.05,246.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.59,236.45l-1.94.24,1.81.76A6.51,6.51,0,0,1,141.59,236.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.17,248.74l.33-2a8.41,8.41,0,0,1-1,.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.64,240.56l2-.07-1.74-.91A8.17,8.17,0,0,1,158.64,240.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,242l1.95.28-1.55-1.21A9.64,9.64,0,0,1,158.06,242Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,243.37l1.88.62-1.31-1.47A9.69,9.69,0,0,1,157.23,243.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63,242.52,141.32,244l1.87-.62A9.59,9.59,0,0,1,142.63,242.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,241.1l-1.55,1.21,2-.28A9.64,9.64,0,0,1,142,241.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.53,243.8l-1,1.69,1.73-1A9.81,9.81,0,0,1,143.53,243.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.56,239.58l-1.74.91,2,.07C141.69,240.24,141.62,239.91,141.56,239.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,246.75l1.53-1.25a9.56,9.56,0,0,1-.82-.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.38,248.4l1-1.71c-.33-.07-.66-.17-1-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.26,248.74l.68-1.87a8.41,8.41,0,0,1-1-.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.59,247.73l1.28-1.5a7.69,7.69,0,0,1-.91-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.26,238.1a8,8,0,1,0-8,8.05A8,8,0,0,0,158.26,238.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.52,223.06s7.32,14.34,9.56,15.63,28.31-.63,28.31-.63a21.5,21.5,0,0,1,2.22-2.91c.47-.29,8.47,5,9.58,5.79s-1.55,8.93-2.12,8.36-9.13-3.94-9.89-5c0,0-29.27,2.88-31.66,1.29s-13.61-14.15-13.61-14.15Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,206.53c-7.69,2.73-10,15.37-1.49,29.26l14.68-6.63S134.29,205.18,130.5,206.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,206.53c-7.69,2.73-10,15.37-1.49,29.26l14.68-6.63S134.29,205.18,130.5,206.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/ice-cream.c6de1a543f17e9f534ce64b600975353.svg";
export { ForwardRef as ReactComponent };